'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { EXIT_INTENT_SIGNAL, SCROLL_DOWN_THRESHOLD_PX, SCROLL_UP_DELTA_PX, SCROLL_UP_QUICK_MS } from '../../config/exitIntent';
import { isTouchDevice } from '../../lib/isTouchDevice';
import { type ExitIntentTrigger, hasExitIntentBeenShown } from './session';
export function useScrollBounceSignal(triggerRef, hasFired) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== hasFired || $[1] !== triggerRef) {
    t0 = () => {
      if (hasFired || hasExitIntentBeenShown() || !isTouchDevice()) {
        return;
      }
      let lastScrollY = window.scrollY;
      let lastScrollTime = Date.now();
      let maxScrollY = window.scrollY;
      const onScroll = () => {
        const currentScrollY = window.scrollY;
        const now = Date.now();
        maxScrollY = Math.max(maxScrollY, currentScrollY);
        const scrolledPastThreshold = maxScrollY >= SCROLL_DOWN_THRESHOLD_PX;
        const scrolledUpFast = lastScrollY - currentScrollY >= SCROLL_UP_DELTA_PX && now - lastScrollTime <= SCROLL_UP_QUICK_MS;
        if (scrolledPastThreshold && scrolledUpFast) {
          triggerRef.current?.(EXIT_INTENT_SIGNAL.mobileScrollBounce);
        }
        lastScrollY = currentScrollY;
        lastScrollTime = now;
      };
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", onScroll);
    };
    t1 = [triggerRef, hasFired];
    $[0] = hasFired;
    $[1] = triggerRef;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}